
const data = {
  "Вина крепкие|163|0|0|12": {},
  "Вина ликерные|212|1|0|30": {},
  "Вина полудесертные|140|0|0|12": {},
  "Вина полусладкие белые и красные |88|0|0|5": {},
  "Вина полусухие белые и красные |78|0|0|3": {},
  "Вина сладкие белые и красные |100|0|0|8": {},
  "Вина сухие белые и красные |64|0|0|0": {},
  "Водка|235|0|0|0": {},
  "Коньяк|239|0|0|2": {},
  "Ликер|299|0|0|40": {},
  "Мартини Бьянко|145|0|0|17": {},
  "Медовуха|65|1|0|16": {},
  "Пиво светлое 11%|42|0|0|5": {},
  "Пиво светлое 20%|75|0|0|8": {},
  "Пиво темное 13%|48|0|0|6": {},
  "Пиво темное 20%|74|0|0|9": {},
  "Саке|98|0|0|4": {},
  "Donat Mg (магниевая)|0|0|0|0": {},
  "Арзни|0|0|0|0": {},
  "Боржоми|0|0|0|0": {},
  "Вода|0|0|0|0": {},
  "Ессентуки №4|0|0|0|0": {},
  "Миргородская|0|0|0|0": {},
  "Нарзан|0|0|0|0": {},
  "Полюстрово|0|0|0|0": {},
  "Славяновская|0|0|0|0": {},
  "Кисель брусничный|75|0|0|20": {},
  "Кисель из абрикосов|54|0|0|14": {},
  "Кисель из земляники|51|0|0|14": {},
  "Кисель из клюквы|55|0|0|15": {},
  "Кисель из овсяных хлопьев|131|4|8|13": {},
  "Кисель из яблок|62|0|0|16": {},
  "Кисель костяничный|38|0|0|10": {},
  "Кисель лимонный|60|0|0|16": {},
  "Кисель молочный|61|3|3|5": {},
  "Кисель морковный|49|0|0|13": {},
  "Кисель тыквенный|102|2|5|13": {},
  "Квас клюквенный|40|0|0|11": {},
  "Квас хлебный|27|0|0|5": {},
  "Квас яблочный|37|0|0|9": {},
  "Кокосовое молоко, свежее|230|2|24|3": {},
  "Коктейль молочный|97|3|4|13": {},
  "Морс брусничный|41|0|0|11": {},
  "Напитки газированные на плодово-ягодных настоях|46|0|0|10": {},
  "Напитки газированные на цитрусовых настоях|33|0|0|8": {},
  "Напитки газированные на эссенциях («Кока-кола», «Пепси-кола»,|38|0|0|9": {},
  "Напиток из боярышника|30|0|0|8": {},
  "Напиток из брусники|80|0|0|21": {},
  "Напиток из тыквы|40|0|0|10": {},
  "Напиток клюквенный|40|0|0|11": {},
  "Напиток яблочный|42|0|0|11": {},
  "Отвар из шиповника|19|0|0|4": {},
  "Сбитень|58|0|1|14": {},
  "Фанта|28|0|0|7": {},
  "Энергетический напиток, AMP|46|0|0|12": {},
  "Энергетический напиток, AMP, без сахара|2|0|0|1": {},
  "Энергетический напиток, Monster (Монстр)|42|0|0|11": {},
  "Энергетический напиток, RED BULL (Ред булл), без сахара, с доб кофеина|5|0|0|1": {},
  "Энергетический напиток, RED BULL (Ред булл), с доб кофеина|45|0|0|11": {},
  "Энергетический напиток, ROCKSTAR|58|0|0|13": {},
  "Энергетический напиток, ROCKSTAR, без сахара|4|0|0|1": {},
  "Энергетический напиток, VAULT Zero, без сахара, со вкусом цитрусовых|1|0|0|1": {},
  "Энергетический напиток, VAULT Zero, со вкусом цитрусовых|49|0|0|13": {},
  "Яблочный пунш|75|0|0|19": {},
  "Сок абрикосовый|55|1|0|13": {},
  "Сок айвовый|51|1|0|11": {},
  "Сок ананасовый|47|0|0|12": {},
  "Сок апельсиновый|60|1|0|13": {},
  "Сок виноградный|70|0|0|16": {},
  "Сок вишнёвый|51|1|0|11": {},
  "Сок гранатовый|56|0|0|14": {},
  "Сок грейпфрутовый|38|0|0|8": {},
  "Сок грушевый|46|0|0|11": {},
  "Сок клюквенный|46|0|0|11": {},
  "Сок лимонный|33|1|0|4": {},
  "Сок мандариновый|45|1|0|10": {},
  "Сок морковный|56|1|0|13": {},
  "Сок персиковый|68|0|0|17": {},
  "Сок свекольный|61|1|0|14": {},
  "Сок сливовый|68|0|0|15": {},
  "Сок томатный|18|1|0|3": {},
  "Сок черноплодно-рябиновый|50|0|0|11": {},
  "Сок черносмородиновый|41|1|0|7": {},
  "Сок шиповниковый|67|0|0|16": {},
  "Сок яблочный|46|1|0|10": {},
  "Какао с молоком|103|3|3|17": {},
  "Какао со сгущенным молоком и сахаром|321|8|8|52": {},
  "Какао со сгущенными сливками|75|3|5|5": {},
  "Кофе жареный в зернах|331|14|14|30": {},
  "Кофе на молоке|64|1|2|12": {},
  "Кофе со сгущенным молоком|75|3|5|5": {},
  "Кофе чёрный без сахара|7|0|1|0": {},
  "Чай зеленый без сахара|0|0|0|0": {},
  "Чай зеленый с сахаром|28|0|0|7": {},
  "Чай с лимоном и сахаром|28|0|0|7": {},
  "Чай с молоком|43|1|1|8": {},
  "Чай с сахаром|28|0|0|7": {},
  "Чай черный без сахара|0|0|0|0": {},
  "Чай черный с сахаром|32|0|0|8": {},
  "Белый гриб (свежий)|34|4|2|1": {},
  "Вешенки (свежие)|33|3|0|4": {},
  "Груздь (свежий)|19|2|1|1": {},
  "Лисички (свежие)|19|2|1|1": {},
  "Маслята (свежие)|18|2|1|1": {},
  "Опята (свежие)|22|2|1|1": {},
  "Подберезовики (свежие)|20|2|1|1": {},
  "Подосиновики (свежие)|22|3|1|1": {},
  "Рыжики (свежие)|22|2|1|2": {},
  "Сморчок (свежий)|31|3|1|2": {},
  "Сыроежки (свежие)|19|2|1|2": {},
  "Трюфели (свежие)|24|3|1|2": {},
  "Чернушка (свежие)|9|2|0|0": {},
  "Шампиньоны (свежие)|27|4|1|0": {},
  "Шитаки (свежие)|34|2|1|4": {},
  "Бисквит|319|11|12|44": {},
  "Вафли|342|3|3|81": {},
  "Галеты|393|10|10|66": {},
  "Кекс шоколадный|356|6|20|40": {},
  "Кулич пасхальный|320|7|14|44": {},
  "Манник|218|6|2|46": {},
  "Медовик|311|8|5|62": {},
  "Ореховое печение|269|7|12|36": {},
  "Печенье|417|8|12|75": {},
  "Печенье овсяное|450|6|18|66": {},
  "Пирожное заварное с кремом (трубочка)|433|4|25|49": {},
  "Пирожное песочное с кремом|485|5|28|52": {},
  "Пирожное, бисквитное|344|5|9|64": {},
  "Пирожное, слоеное с кремом|544|5|39|47": {},
  "Пончики|329|7|15|45": {},
  "Пряники|336|5|3|78": {},
  "Торт Зебра|271|9|13|32": {},
  "Торт Муравейник|452|5|29|45": {},
  "Торт Прага|284|6|13|39": {},
  "Шарлотка|146|3|2|31": {},
  "Безе|305|2|0|79": {},
  "Гематоген|354|6|3|76": {},
  "Драже|516|10|35|43": {},
  "Засахаренный кишмиш|225|0|0|60": {},
  "Зефир|326|1|0|80": {},
  "Карамель глазированная|378|1|1|93": {},
  "Карамель, леденцовая|384|0|0|96": {},
  "Козинаки|419|2|20|62": {},
  "Конфеты неглазированные|402|3|10|80": {},
  "Конфеты неглазированные шоколадные|491|4|26|59": {},
  "Конфеты неглазированные, молочные|358|3|4|82": {},
  "Конфеты неглазированные, помадные|445|4|16|71": {},
  "Лукум сбивной|316|1|1|79": {},
  "Мармелад|321|0|0|79": {},
  "Мед пчелиный|328|1|0|80": {},
  "Пастила|324|1|0|80": {},
  "Плитки кондитерские|537|8|35|48": {},
  "Сахар-песок|399|0|0|100": {},
  "Сахар-рафинад|400|0|0|100": {},
  "Сахарная пудра|374|0|0|100": {},
  "Сахарный сироп|300|0|0|80": {},
  "Халва, подсолнечная ванильная|516|12|30|54": {},
  "Глазурь шоколадная|542|5|35|53": {},
  "Горячий шоколад|73|2|2|11": {},
  "Какао-порошок|289|24|15|10": {},
  "Шоколад в порошке|483|5|24|65": {},
  "Шоколад горький|539|6|35|48": {},
  "Шоколад молочный|554|10|35|50": {},
  "Шоколад ореховый|534|7|34|50": {},
  "Шоколад полугорький|549|5|35|53": {},
  "Шоколад пористый молочный|546|7|36|53": {},
  "Шоколад сладкий|550|3|34|58": {},
  "Шоколад сливочный|560|6|36|54": {},
  "Шоколадная паста|536|8|31|57": {},
  "Шоколадный крем|272|4|13|38": {},
  "Шоколадный соус|140|3|8|16": {},
  "Бобы|57|6|0|9": {},
  "Горох, зерно|298|21|2|50": {},
  "Горох, лущеный|299|23|2|48": {},
  "Горошек, зеленый, замороженный, неприготовленный|77|5|0|9": {},
  "Горошек, зеленый, сушеный|55|5|0|8": {},
  "Горошек, зеленый, сырой|81|5|0|9": {},
  "Маш (фасоль золотистая)|309|24|1|46": {},
  "Нут (турецкий горох)|364|19|6|61": {},
  "Соя, зерно|364|35|17|17": {},
  "Фасоль|298|21|2|47": {},
  "Фасоль (стручок)|23|3|0|3": {},
  "Чечевица, зерно|295|24|2|46": {},
  "Дикий рис|357|15|1|69": {},
  "Зерно пшеницы|305|12|2|60": {},
  "Крупа гречневая ядрица|308|13|3|57": {},
  "Крупа кукурузная|328|8|1|71": {},
  "Крупа манная|333|10|1|71": {},
  "Крупа овсяная|342|12|6|60": {},
  "Крупа перловая|315|9|1|67": {},
  "Крупа пшеничная|304|13|3|58": {},
  "Крупа пшено шлифованное|342|12|3|67": {},
  "Крупа рисовая|333|7|1|74": {},
  "Крупа ячневая|313|10|1|65": {},
  "Кукуруза, свежая в початках молочной спелости|338|10|5|68": {},
  "Кукурузные хлопья|325|8|1|75": {},
  "Отруби овсяные|246|17|7|51": {},
  "Отруби пшеничные|165|16|4|17": {},
  "Саго (крупа из крахмала)|336|16|1|70": {},
  "Сорго|323|11|4|60": {},
  "Толокно|363|13|6|65": {},
  "Хлопья «Геркулес», овсяные|352|12|6|62": {},
  "Каша геркулесовая (на воде)|84|3|1|15": {},
  "Каша геркулесовая (на молоке)|105|3|4|14": {},
  "Каша гречневая (на воде)|90|3|1|17": {},
  "Каша гречневая (на молоке)|163|6|2|31": {},
  "Каша манная (на воде)|80|3|0|17": {},
  "Каша манная (на молоке)|98|3|3|16": {},
  "Каша овсяная (на воде)|88|2|3|15": {},
  "Каша овсяная (на молоке)|102|3|4|14": {},
  "Каша перловая (на воде)|106|3|0|23": {},
  "Каша пшенная (на воде)|90|3|1|17": {},
  "Каша пшенная (на молоке)|108|4|3|16": {},
  "Каша рисовая (на воде)|78|2|0|17": {},
  "Каша рисовая (на молоке)|97|3|3|16": {},
  "Каша ячневая (на воде)|96|2|3|15": {},
  "Рис белый вареный|116|2|1|25": {},
  "Маргарин молочный столовый|743|0|82|1": {},
  "Маргарин низкокалорийный|545|1|60|1": {},
  "Маргарин сливочный|743|0|82|1": {},
  "Маргарин, безмолочный|744|0|83|1": {},
  "Масло сладко-сливочное «Бутербродное»|566|1|62|2": {},
  "Масло сладко-сливочное «Вологодское»|748|1|83|1": {},
  "Масло сладко-сливочное несоленое|748|1|83|1": {},
  "Масло сладко-сливочное несоленое «Любительское»|709|1|78|1": {},
  "Масло сладко-сливочное соленое «Любительское»|700|1|77|1": {},
  "Масло сливочное|748|1|83|1": {},
  "Масло сливочное несоленое «Крестьянское»|661|1|73|1": {},
  "Масло сливочное соленое «Крестьянское»|647|1|72|1": {},
  "Масло топленое|892|0|99|0": {},
  "Масло абрикосовое|899|0|100|0": {},
  "Масло арахисовое|899|0|100|0": {},
  "Масло горчичное|898|0|100|0": {},
  "Масло какао|899|0|100|0": {},
  "Масло кокосовое|899|0|100|0": {},
  "Масло конопляное|899|0|100|0": {},
  "Масло кукурузное|899|0|100|0": {},
  "Масло кунжутное|899|0|100|0": {},
  "Масло льняное|898|0|100|0": {},
  "Масло маковое|898|0|100|0": {},
  "Масло оливковое|898|0|100|0": {},
  "Масло пальмовое|899|0|100|0": {},
  "Масло персиковое|899|0|100|0": {},
  "Масло подсолнечное|899|0|100|0": {},
  "Масло рапсовое|899|0|100|0": {},
  "Масло растительное, лесной орех|884|0|100|0": {},
  "Масло сливовое|899|0|100|0": {},
  "Масло соевое|899|0|100|0": {},
  "Масло хлопковое|899|0|100|0": {},
  "Жир бараний|897|0|100|0": {},
  "Жир говяжий|896|0|100|0": {},
  "Жир из печени трески|898|0|100|0": {},
  "Жир кулинарный|897|0|100|0": {},
  "Жир куриный|897|0|100|0": {},
  "Жир растительный|898|0|100|0": {},
  "Жир рыбий, из печени трески|902|0|100|0": {},
  "Жир рыбий, лосось|902|0|100|0": {},
  "Жир свиной|896|0|100|0": {},
  "Молоко кобылье|41|2|1|6": {},
  "Молоко козье|67|3|4|5": {},
  "Молоко коровье, ацидофильное дрожжевое 3,2%|58|3|3|5": {},
  "Молоко коровье, белковое 1%|52|4|1|6": {},
  "Молоко коровье, обезжиренное 0,5%|31|3|0|5": {},
  "Молоко коровье, топленое 1%|40|3|1|5": {},
  "Молоко коровье, топленое 6%|84|3|6|5": {},
  "Молоко овечье|110|6|8|5": {},
  "Молоко пастеризованное 3,2% жирности|60|3|3|5": {},
  "Молоко пастеризованное 3,5% жирности|62|3|4|5": {},
  "Молоко пастеризованное нежирное|32|3|0|5": {},
  "Молоко пастеризованное, 1,5% жирности|45|3|2|5": {},
  "Молоко пастеризованное, 2,5% жирности|54|3|3|5": {},
  "Молоко сгущеное, с сахаром, нежирное|259|8|0|57": {},
  "Молоко стерилизованное 3,2% жирности|60|3|3|5": {},
  "Молоко стерилизованное 3,5% жирности|63|3|4|5": {},
  "Молоко стерилизованное, 1,5% жирности|45|3|2|5": {},
  "Молоко стерилизованное, 2,5% жирности|54|3|3|5": {},
  "Молоко стерилизованное, 3,0% жирности|58|3|3|5": {},
  "Молоко сухое цельное, 25,0% жирности|483|24|25|39": {},
  "Молоко сухое, 15,0% жирности|432|29|15|45": {},
  "Молоко сухое, 25% жирности|469|24|25|39": {},
  "Молоко сухое, обезжиренное в герметичной упаковке|362|33|1|53": {},
  "Соевое молоко, (все вкусы), обогащенное|45|3|2|3": {},
  "Йогурт 1,5% жирности|57|4|2|6": {},
  "Йогурт 3,2% жирности|68|5|3|4": {},
  "Йогурт 6,0% жирности|92|5|6|4": {},
  "Йогурт обычный (обезжиренное молоко)|56|6|0|8": {},
  "Йогурт обычный (с низким содерж. жира)|63|5|2|7": {},
  "Йогурт плодово-ягодный, 1,5% жирности|90|4|2|14": {},
  "Йогурт сладкий 3,2% жирности|87|5|3|9": {},
  "Йогурт сладкий 6,0% жирности|112|5|6|9": {},
  "Йогурт сублимационной сушки|75|3|5|5": {},
  "Йогурт, 1,5%, сладкий|52|4|2|6": {},
  "Тофу йогурт|94|4|2|16": {},
  "Айран (тан)|24|1|2|1": {},
  "Ацидофилин, нежирный|31|3|0|4": {},
  "Варенец 2,5% жирности|53|3|3|4": {},
  "Кефир 1% жирности|40|3|1|4": {},
  "Кумыс из кобыльего молока|50|2|2|5": {},
  "Кумыс коровий|44|2|2|5": {},
  "Мацони|65|3|4|5": {},
  "Простокваша, 1% жирности|40|3|1|4": {},
  "Ряженка 2,5% жирности|54|3|3|4": {},
  "Ряженка 4,0% жирности|67|3|4|4": {},
  "Ряженка 6,0% жирности|85|3|6|4": {},
  "Ряженка, 1% жирности|40|3|1|4": {},
  "Сметана 10,0% жирности|119|3|10|4": {},
  "Сметана 15,0% жирности|162|3|15|4": {},
  "Сметана 20,0% жирности|206|3|20|3": {},
  "Сметана 25,0% жирности|250|2|25|3": {},
  "Сметана 30,0% жирности|293|2|30|3": {},
  "Сметана, 0% обезжиренная|74|3|0|16": {},
  "Сыворотка подсырная|63|3|4|5": {},
  "Сыворотка творожная|18|1|0|4": {},
  "Морожение молочное с плодами и ягодами|124|3|3|21": {},
  "Морожение сливочное с плодами и ягодами|166|3|8|20": {},
  "Мороженое, молочное|132|4|4|21": {},
  "Мороженое, молочное, клубничное|118|3|3|21": {},
  "Мороженое, молочное, крем-брюле|138|4|4|23": {},
  "Мороженое, молочное, ореховое|126|4|4|21": {},
  "Мороженое, молочное, с шоколадной глазурью|231|3|15|21": {},
  "Мороженое, молочное, шоколадное|133|4|4|21": {},
  "Мороженое, пломбир|232|4|15|20": {},
  "Мороженое, пломбир, в шоколадной глазури|310|3|24|20": {},
  "Мороженое, пломбир, клубничный|206|3|12|21": {},
  "Мороженое, пломбир, крем-брюле|240|4|15|22": {},
  "Мороженое, пломбир, ореховый|226|4|15|20": {},
  "Мороженое, пломбир, шоколадный|231|4|15|20": {},
  "Мороженое, сливочное|183|4|10|19": {},
  "Мороженое, сливочное, клубничное|161|3|8|20": {},
  "Мороженое, сливочное, крем-брюле|191|4|10|21": {},
  "Мороженое, сливочное, ореховое|178|4|10|19": {},
  "Мороженое, сливочное, с шоколадной глазурью|271|3|20|19": {},
  "Мороженое, сливочное, шоколадное|185|4|10|20": {},
  "Эскимо|124|3|4|21": {},
  "Сливки пастеризованные 10,0% жирности|119|3|10|5": {},
  "Сливки пастеризованные 20,0% жирности|207|3|20|4": {},
  "Сливки пастеризованные 35,0% жирности|337|2|35|3": {},
  "Сливки пастеризованные 8,0% жирности|102|3|8|5": {},
  "Сливки сгущенные|75|3|5|5": {},
  "Сливки сгущенные, с сахаром|75|3|5|5": {},
  "Сливки стерилизованные 10,0% жирности|119|3|10|4": {},
  "Сливки стерилизованные 25,0% жирности|251|2|25|4": {},
  "Сливки сухие 42,0% жирности|577|19|42|30": {},
  "Сливки сухие, высокожирные|567|19|42|30": {},
  "Сливки сухие, с какао|567|19|42|30": {},
  "Сливки сухие, с сахаром|567|19|42|30": {},
  "Сливки, 20% жирности|205|3|20|4": {},
  "Сливки, 35% жирности|336|2|35|3": {},
  "Брынза коровья|262|22|19|0": {},
  "Паста сырная|555|15|54|2": {},
  "Сыр адыгейский|264|20|20|2": {},
  "Сыр Амбер|220|31|10|10": {},
  "Сыр бри, мягкий скоропортящийся|334|21|28|1": {},
  "Сыр гауда|356|25|27|2": {},
  "Сыр голландский|356|26|27|4": {},
  "Сыр домашний нежирный|86|18|1|2": {},
  "Сыр Дор Блю|354|21|30|0": {},
  "Сыр камамбер|324|15|29|0": {},
  "Сыр козий, мягкий|268|19|21|1": {},
  "Сыр козий, полутвердый|364|22|30|3": {},
  "Сыр козий, твердый|452|31|36|2": {},
  "Сыр Маасдам|350|24|26|0": {},
  "Сыр моцарелла|300|22|22|2": {},
  "Сыр мягкий|332|20|28|0": {},
  "Сыр Ольтермани 17%|270|30|17|3": {},
  "Сыр осетинский|356|26|27|4": {},
  "Сыр пармезан|431|39|29|4": {},
  "Сыр плавленый|331|22|27|0": {},
  "Сыр плавленый, колбасный копченый|275|21|19|4": {},
  "Сыр рокфор|335|21|28|0": {},
  "Сыр российский|364|23|30|0": {},
  "Сыр советский|385|24|31|0": {},
  "Сыр Сулугуни|286|21|22|0": {},
  "Сыр твердый|356|26|27|4": {},
  "Сыр фета|264|14|21|4": {},
  "Сыр чеддер|380|24|31|0": {},
  "Сыр швейцарский|391|25|32|0": {},
  "Сырные палочки|315|14|28|2": {},
  "Вареники ленивые отварные|355|17|24|20": {},
  "Масса творожная|232|12|17|10": {},
  "Масса творожная сладкая с ванилином 20,0% жирности|287|12|20|15": {},
  "Масса творожная сладкая с изюмом, 23,0% жирности|345|7|23|27": {},
  "Сырки глазированные с ванилином 10,9% жирности|270|9|11|33": {},
  "Сырки глазированные с ванилином 27,7% жирности|413|8|28|33": {},
  "Сырки творожные детские, 23,0% жирности|319|9|23|19": {},
  "Сырники из творога|300|13|19|20": {},
  "Сырок творожный|232|12|17|10": {},
  "Творог жирный, 18%|232|14|18|3": {},
  "Творог мягкий, диетический, 11%|178|16|11|3": {},
  "Творог мягкий, диетический, 4%|136|21|4|3": {},
  "Творог мягкий, диетический, нежирный, 0.6%|110|22|1|3": {},
  "Творог нежирный, 0.6%|88|18|1|2": {},
  "Творог полужирный, 9%|169|18|9|3": {},
  "Крахмал картофельный|313|0|0|78": {},
  "Крахмал кукурузный|343|1|1|84": {},
  "Лапша домашняя|256|10|3|51": {},
  "Макаронные изделия, высшего сорта, витаминизированные|337|10|1|70": {},
  "Макаронные изделия, высшего сорта, молочные|345|12|3|67": {},
  "Макароны из муки 1 сорта|333|11|2|68": {},
  "Мука высшего сорта из мягких сортов пшеницы|334|10|1|71": {},
  "Мука гречневая|353|14|1|72": {},
  "Мука диетическая рисовая|356|7|1|80": {},
  "Мука из зародышей пшеницы|335|34|8|33": {},
  "Мука кукурузная|331|7|2|72": {},
  "Мука овсяная|369|13|7|65": {},
  "Мука пшеничная, второго сорта|324|12|2|64": {},
  "Мука пшеничная, высшего сорта|334|11|1|70": {},
  "Мука пшеничная, первого сорта|329|11|2|68": {},
  "Мука ржаная, обдирная|298|9|2|62": {},
  "Мука ржаная, обойная|294|11|2|59": {},
  "Мука ржаная, сеяная|305|7|1|66": {},
  "Мука соевая необезжиренная|385|37|19|18": {},
  "Мука соевая обезжиренная|291|49|1|22": {},
  "Мука соевая полуобезжиренная|334|43|10|19": {},
  "Мука ячменная|265|10|2|56": {},
  "Баранина|203|16|15|0": {},
  "Буйволятина|195|19|13|0": {},
  "Верблюжатина|160|19|9|0": {},
  "Говядина, вырезка|218|19|16|0": {},
  "Козлятина|216|18|16|0": {},
  "Конина|167|20|10|0": {},
  "Мясо косули|138|21|6|0": {},
  "Мясо кролика|183|21|11|0": {},
  "Мясо лося|101|21|2|0": {},
  "Мясо сайгака|208|21|14|0": {},
  "Мясо яка|112|20|4|0": {},
  "Мясо, ягнятина|192|16|14|0": {},
  "Оленина|155|20|9|0": {},
  "Поросятина|109|21|3|0": {},
  "Свинина беконная|318|17|28|0": {},
  "Телятина молочная|97|20|2|0": {},
  "Бройлеры (цыплята)|220|19|16|0": {},
  "Глухарь|254|18|20|1": {},
  "Гуси|412|15|39|0": {},
  "Гусята|326|17|29|0": {},
  "Индейка|276|20|22|0": {},
  "Индюшата|183|19|12|1": {},
  "Куриная грудка (филе)|113|24|2|0": {},
  "Куриный окорочок|185|21|11|0": {},
  "Курица|238|18|18|0": {},
  "Куропатка|254|18|20|1": {},
  "Перепелка|239|18|19|0": {},
  "Рябчик|254|18|20|1": {},
  "Тетерев|254|18|20|1": {},
  "Утка|405|16|38|0": {},
  "Утята|309|16|27|0": {},
  "Фазан|254|18|20|1": {},
  "Цыплята|140|19|7|1": {},
  "Вымя говяжье|173|12|14|0": {},
  "Легкие бараньи|83|16|2|0": {},
  "Легкие говяжьи|103|15|5|0": {},
  "Легкие свиное|92|15|4|0": {},
  "Мозги бараньи|123|10|9|0": {},
  "Мозги говяжьи|127|12|9|1": {},
  "Мозги свинные|119|11|9|1": {},
  "Печень баранья|101|19|3|0": {},
  "Печень говяжья|135|20|4|4": {},
  "Печень гусиная|412|15|39|0": {},
  "Печень индейки|228|18|16|2": {},
  "Печень куриная|140|20|6|1": {},
  "Печень свиная|109|19|4|5": {},
  "Печень телячья|98|17|3|0": {},
  "Печень утиная|405|16|38|0": {},
  "Почки бараньи|77|14|3|0": {},
  "Почки говяжьи|86|15|3|2": {},
  "Почки свиные|92|15|4|3": {},
  "Почки телячьи|66|13|2|0": {},
  "Сердце баранье|86|14|4|0": {},
  "Сердце говяжье|96|16|4|2": {},
  "Сердце куриное|159|16|10|1": {},
  "Сердце свиное|101|16|4|3": {},
  "Язык бараний|195|13|16|0": {},
  "Язык говяжий|173|16|12|2": {},
  "Язык свиной|208|16|16|2": {},
  "Язык телячий|163|14|12|0": {},
  "Ветчина особая|126|18|6|0": {},
  "Колбаса вареная, докторская|257|13|22|2": {},
  "Колбаса вареная, любительская|301|12|28|0": {},
  "Колбаса вареная, молочная|252|12|23|0": {},
  "Колбаса вареная, столовая|234|11|20|2": {},
  "Колбаса вареная, чайная|216|12|18|2": {},
  "Колбаса варено-копченая|350|20|30|0": {},
  "Колбаса варено-копченая московская|406|19|37|0": {},
  "Колбаса варено-копченая, любительская|420|17|39|0": {},
  "Колбаса полукопченая одесская|402|15|38|0": {},
  "Колбаса полукопченая, армавирская|423|15|40|0": {},
  "Колбаса полукопченая, краковская|466|16|45|0": {},
  "Колбаса полукопченая, минская|259|23|17|3": {},
  "Колбаса полукопченая, полтавская|417|16|39|0": {},
  "Колбаса полукопченая, таллинская|373|17|34|0": {},
  "Колбаса полукопченая, украинская|376|17|34|0": {},
  "Колбаса сырокопченая дорожная|498|17|48|0": {},
  "Колбаса сырокопченая зернистая|606|10|63|0": {},
  "Колбаса сырокопченая олимпийская|436|21|39|0": {},
  "Колбаса сырокопченая свиная|566|13|57|0": {},
  "Колбаса сырокопченая, брауншвейгская|491|28|42|0": {},
  "Колбаса сырокопченая, любительская|514|21|48|0": {},
  "Колбаса сырокопченая, московская|473|25|42|0": {},
  "Колбаса сырокопченая, столичная|487|24|43|0": {},
  "Охотничьи колбаски|463|25|40|0": {},
  "Сервелат|461|24|41|0": {},
  "Сардельки говяжьи|215|11|18|1": {},
  "Сардельки из говядины и свинины|323|14|28|3": {},
  "Сардельки из говядины и свинины (копченые)|297|12|26|2": {},
  "Сардельки из курицы|176|19|10|0": {},
  "Сардельки из свинины, говядины и индейки (копченые)|186|15|14|2": {},
  "Сардельки свиные|333|14|29|3": {},
  "Сосиски говяжьи|226|10|20|1": {},
  "Сосиски молочные|261|11|24|0": {},
  "Сосиски русские|250|11|22|2": {},
  "Сосиски свиные|324|12|31|0": {},
  "Сосиски столичные|234|12|20|1": {},
  "Буженина|510|15|50|0": {},
  "Грудинка копчено-запеченная (свинина)|514|10|53|0": {},
  "Грудинка сырокопченая (свинина)|605|9|63|0": {},
  "Корейка копчено-запеченная (свинина)|475|10|48|0": {},
  "Корейка сырокопченая (свинина)|469|11|47|0": {},
  "Окорок варено-копчёный|510|15|50|0": {},
  "Шпик свиной|841|1|93|0": {},
  "Шпик свиной, соленый|816|1|90|0": {},
  "Артишоки|47|3|0|11": {},
  "Баклажаны|24|1|0|5": {},
  "Батат|60|2|0|14": {},
  "Брокколи|34|3|0|7": {},
  "Брюква|37|1|0|8": {},
  "Кабачки|24|1|0|5": {},
  "Капуста белокочанная|28|2|0|5": {},
  "Капуста брюссельская|35|5|0|3": {},
  "Капуста кольраби|44|3|0|8": {},
  "Капуста краснокочанная|26|1|0|5": {},
  "Капуста пекинская|16|1|0|2": {},
  "Капуста савойская|28|1|0|6": {},
  "Капуста цветная|30|3|0|4": {},
  "Картофель|77|2|0|16": {},
  "Корнишоны|28|1|0|6": {},
  "Лук репчатый|41|1|0|8": {},
  "Морковь, желтая|33|1|0|7": {},
  "Морковь, красная|35|1|0|7": {},
  "Огурцы|15|1|0|3": {},
  "Оливки (мякоть)|296|2|24|19": {},
  "Патиссон|19|1|0|4": {},
  "Перец сладкий|26|1|0|5": {},
  "Помидоры (томаты)|20|1|0|4": {},
  "Редис|20|1|0|3": {},
  "Редька черная|36|2|0|7": {},
  "Репа|32|2|0|6": {},
  "Свекла|42|2|0|9": {},
  "Топинамбур|61|2|0|13": {},
  "Тыква|22|1|0|4": {},
  "Базилик, свежий|23|3|1|1": {},
  "Ботва свекольная|28|1|0|6": {},
  "Душица|25|2|0|5": {},
  "Кориандр (кинза)|216|3|0|55": {},
  "Крапива ранняя|25|2|0|5": {},
  "Лук зеленый (перо)|20|1|0|3": {},
  "Лук порей|36|2|0|6": {},
  "Лук репчатый, сушеный|219|8|3|43": {},
  "Пастернак (корень)|47|1|1|9": {},
  "Перечная мята, свежая|70|4|1|7": {},
  "Петрушка|49|4|0|8": {},
  "Петрушка (корень)|51|2|1|10": {},
  "Ревень|16|1|0|3": {},
  "Розмарин, свежий|131|3|6|7": {},
  "Салат|16|2|0|2": {},
  "Сельдерей|13|1|0|2": {},
  "Сельдерей (корень)|34|1|0|7": {},
  "Сельдерей корень сушеный|186|8|2|37": {},
  "Спаржа|21|2|0|3": {},
  "Укроп|40|3|1|6": {},
  "Хрен корень|59|3|0|11": {},
  "Черемша|35|2|0|7": {},
  "Чеснок луковица|149|7|1|30": {},
  "Шпинат|23|3|0|2": {},
  "Щавель|22|2|0|3": {},
  "Эстрагон|25|2|0|5": {},
  "Абрикос-ядро|519|25|45|3": {},
  "Арахис|552|26|45|10": {},
  "Бразильский орех, сушеный, неочищенный|656|14|66|5": {},
  "Вишня-ядро|422|22|31|16": {},
  "Какао тертое|559|14|49|14": {},
  "Какао-бобы|565|13|53|9": {},
  "Кедровый орех|674|24|60|21": {},
  "Конопля-семя|373|20|33|0": {},
  "Кунжут-семя|565|19|49|12": {},
  "Льняное семя|534|18|42|2": {},
  "Мак-семя|556|18|48|15": {},
  "Макадамия (австралийский орех), сырые|718|8|76|5": {},
  "Миндаль|575|21|49|10": {},
  "Орех грецкий|656|16|61|11": {},
  "Орех кешью|600|19|49|23": {},
  "Орех мускатный|556|20|50|7": {},
  "Орех пекан|691|9|72|4": {},
  "Подсолнечник-семя|601|21|53|11": {},
  "Рапс-семя|544|31|44|7": {},
  "Семена тыквы, Семечки, сквош, целые, жаренные, с доб. соли|446|19|19|35": {},
  "Слива-ядро|476|29|40|0": {},
  "Фисташки|556|20|50|7": {},
  "Фундук|651|15|62|9": {},
  "Фундук жареный|703|18|66|9": {},
  "Ядро ореха арахиса жареное|626|26|52|13": {},
  "Ядро ореха миндаля жареное|642|22|56|12": {},
  "Амур|88|18|2|0": {},
  "Белуга|88|18|2|0": {},
  "Вобла|95|18|3|0": {},
  "Горбуша|140|21|7|0": {},
  "Ёрш|88|18|2|0": {},
  "Камбала|90|16|3|0": {},
  "Карась|87|18|2|0": {},
  "Карп|112|16|5|0": {},
  "Кета|127|19|6|0": {},
  "Кефаль|88|18|2|0": {},
  "Килька|137|17|8|0": {},
  "Корюшка зубастая|102|15|5|0": {},
  "Лещ|105|17|4|0": {},
  "Лосось атлантический (семга)|153|20|8|0": {},
  "Макрель|113|21|3|0": {},
  "Минога|88|18|2|0": {},
  "Минтай|72|16|1|0": {},
  "Мойва|116|13|7|0": {},
  "Муксун|88|18|2|0": {},
  "Навага|69|15|1|0": {},
  "Налим|88|18|2|0": {},
  "Окунь морской|103|18|3|0": {},
  "Окунь речной|82|19|1|0": {},
  "Омуль|88|18|2|0": {},
  "Осетр|164|16|11|0": {},
  "Палтус|196|13|16|0": {},
  "Плотва|88|18|2|0": {},
  "Путассу|82|19|1|0": {},
  "Рыбец|88|18|2|0": {},
  "Сазан|97|18|3|0": {},
  "Сайра|205|20|14|0": {},
  "Салака|125|17|6|0": {},
  "Сардина|166|19|10|0": {},
  "Севрюга|160|17|10|0": {},
  "Сельдь иваси|182|21|11|0": {},
  "Скумбрия|191|18|13|0": {},
  "Сом|115|17|5|0": {},
  "Ставрида|114|19|5|0": {},
  "Стерлядь|88|18|2|0": {},
  "Судак|84|18|1|0": {},
  "Треска|69|16|1|0": {},
  "Тунец|139|24|5|0": {},
  "Тюлька|88|18|2|0": {},
  "Угорь|333|15|31|0": {},
  "Форель|148|21|7|0": {},
  "Хамса|88|18|2|0": {},
  "Хек|86|17|2|0": {},
  "Щука|84|18|1|0": {},
  "Язык морской|88|10|5|0": {},
  "Водоросли|25|2|0|5": {},
  "Икра белужья зернистая|235|27|14|1": {},
  "Икра вобельная пробойная|88|18|2|0": {},
  "Икра горбуши зернистая|230|31|12|1": {},
  "Икра кеты зернистая|249|32|13|1": {},
  "Икра лещевая пробойная|88|18|2|0": {},
  "Икра минтая пробойная|132|28|2|1": {},
  "Икра осетровая зернистая|200|28|9|1": {},
  "Икра осетровая паюсная|289|38|15|2": {},
  "Икра сазанья пробойная|88|18|2|0": {},
  "Икра севрюги зернистая|221|28|12|1": {},
  "Икра щучья|87|17|2|0": {},
  "Кальмар (мясо)|100|18|2|2": {},
  "Китовое мясо|119|23|3|0": {},
  "Краб камчатский (мясо)|96|16|4|0": {},
  "Крабовые палочки|88|18|2|0": {},
  "Креветка (мясо) варено-мороженая|98|21|2|0": {},
  "Мидии|77|12|2|3": {},
  "Моллюск рапана|77|17|1|0": {},
  "Мясо ластоногих|113|25|2|0": {},
  "Мясо трепанга|35|7|1|0": {},
  "Осьминог|82|15|1|2": {},
  "Раки морские (лангуст, омар)|89|19|1|1": {},
  "Раки речные|76|16|1|1": {},
  "Устрица|72|9|2|5": {},
  "Филе морского гребешка|88|18|2|0": {},
  "Бекон соевый|310|11|30|4": {},
  "Вермишель, из сои|331|0|0|78": {},
  "Колбаса соевая|257|19|18|10": {},
  "Мисо (соевая паста)|199|12|6|21": {},
  "Натто (из сброженных соевых бобов)|212|18|11|9": {},
  "Окара (соевый жмых)|77|3|2|13": {},
  "Рыбные палочки соевые|290|23|18|3": {},
  "Соевые бургеры (котлета)|177|16|6|14": {},
  "Соевые чипсы, соленые|385|27|7|50": {},
  "Сосиски соевые|233|20|14|8": {},
  "Соя, белковый изолят (дериват)|338|81|3|2": {},
  "Темпе|193|19|11|9": {},
  "Темпе (приготовленный)|196|18|11|9": {},
  "Тофу мягкий|61|7|4|2": {},
  "Тофу сырой, обычкый|76|8|5|2": {},
  "Тофу твердый|70|8|4|1": {},
  "Тофу экстра твертдый|91|10|6|2": {},
  "Аджика|59|1|4|6": {},
  "Винный уксус (3%)|9|0|0|0": {},
  "Гвоздика молотая|323|6|20|27": {},
  "Горчица столовая|418|5|40|10": {},
  "Дрожжи прессованные (*эргостерин)|109|13|3|9": {},
  "Желатин пищевой|355|87|0|1": {},
  "Имбирь корень, сырой|80|2|1|16": {},
  "Кардамон|311|11|7|41": {},
  "Карри, порошок|275|13|14|25": {},
  "Кетчуп|97|2|0|25": {},
  "Корица|247|4|1|28": {},
  "Куркума, молотая|295|8|10|44": {},
  "Лавровый лист|313|8|8|49": {},
  "Майонез «Провансаль», 67%|629|3|67|4": {},
  "Майонез диетический, 19% жира|231|0|19|16": {},
  "Майонез диетический, без холестерина, 33% жира|333|1|33|7": {},
  "Майонез, сделан с тофу (соевый сыр), 32% жира|322|6|32|2": {},
  "Муксатный орех, молотый|463|6|36|29": {},
  "Перец жгучий красный|40|2|0|7": {},
  "Перец молотый красный|318|12|17|29": {},
  "Перец черный горошек|255|11|3|38": {},
  "Перечная приправа|138|3|11|7": {},
  "Соевый соус|51|6|0|7": {},
  "Соль поваренная пищевая|0|0|0|0": {},
  "Специи, имбирь, молотый|335|9|4|58": {},
  "Сырный соус|174|7|13|6": {},
  "Тимьян, чабрец, сушеный|210|9|7|27": {},
  "Тмин|333|20|15|12": {},
  "Уксус 9%|11|0|0|3": {},
  "Хмели-сунели|418|5|40|10": {},
  "Цедра|16|1|0|3": {},
  "Шафран|310|11|6|62": {},
  "Абрикосы|44|1|0|9": {},
  "Авокадо|160|2|15|2": {},
  "Айва|48|1|1|10": {},
  "Алыча|34|0|0|8": {},
  "Ананас|52|0|0|12": {},
  "Апельсин|43|1|0|8": {},
  "Арбуз|27|1|0|6": {},
  "Банан|96|2|1|21": {},
  "Виноград|72|1|1|15": {},
  "Гранат|72|1|1|15": {},
  "Грейпфрут|35|1|0|7": {},
  "Груша|47|0|0|10": {},
  "Дыня|35|1|0|7": {},
  "Изюм|299|3|1|79": {},
  "Инжир|54|1|0|12": {},
  "Киви|47|1|0|8": {},
  "Кишмиш|38|0|0|10": {},
  "Лимон|34|1|0|3": {},
  "Манго|60|1|0|13": {},
  "Мандарин|38|1|0|8": {},
  "Нектарин|44|1|0|9": {},
  "Папайя|43|1|0|9": {},
  "Персик|45|1|0|10": {},
  "Помело|38|1|0|9": {},
  "Слива (садовая)|49|1|0|10": {},
  "Фейхоа|35|1|1|7": {},
  "Хурма|67|1|0|15": {},
  "Яблоки, сырые, без кожицы|48|0|0|12": {},
  "Яблоки, сырые, с кожицей|52|0|0|11": {},
  "Абрикосы сушеные без косточки (курага)|232|5|0|51": {},
  "Абрикосы сушеные с косточкой (урюк)|242|5|0|53": {},
  "Виноград сушеный (кишмиш)|281|2|1|66": {},
  "Груша сушеная|270|2|1|63": {},
  "Инжир сушеный|257|3|1|58": {},
  "Персик сушеный|254|3|0|58": {},
  "Слива сушеная (чернослив)|256|2|1|58": {},
  "Финики|292|3|1|69": {},
  "Цукаты|216|3|0|55": {},
  "Цукаты морковные|300|3|0|71": {},
  "Шиповник сухой|284|3|1|48": {},
  "Яблоки сушеные|253|2|0|59": {},
  "Барбарис|30|0|0|8": {},
  "Боярышник|53|0|0|14": {},
  "Брусника|46|1|1|8": {},
  "Вишня|52|1|0|11": {},
  "Голубика|39|1|1|7": {},
  "Ежевика|34|2|1|4": {},
  "Жимолость|30|0|0|8": {},
  "Земляника (садовая), клубника|41|1|0|8": {},
  "Ирга|45|0|0|12": {},
  "Калина|26|0|0|7": {},
  "Кизил|40|1|0|10": {},
  "Клюква|28|1|0|4": {},
  "Крыжовник|45|1|0|9": {},
  "Малина|46|1|1|8": {},
  "Можжевельник|116|0|0|31": {},
  "Морошка|40|1|1|7": {},
  "Облепиха|82|1|5|6": {},
  "Рябина садовая красная|50|1|0|9": {},
  "Рябина черноплодная|55|2|0|11": {},
  "Смородина белая|42|1|0|8": {},
  "Смородина красная|43|1|0|8": {},
  "Смородина черная|44|1|0|7": {},
  "Терн|54|2|0|9": {},
  "Черемуха|0|0|0|0": {},
  "Черешня|52|1|0|11": {},
  "Черника|44|1|1|8": {},
  "Шелковица|50|1|0|13": {},
  "Шиповник|109|2|1|22": {},
  "Баранки простые|311|10|1|64": {},
  "Батон нарезной|262|8|3|51": {},
  "Бублики простые|276|9|1|57": {},
  "Бублики, украинские с маком|336|16|1|70": {},
  "Булка черкизовская|336|16|1|70": {},
  "Булки городские|265|8|2|53": {},
  "Булочки сдобные|339|8|9|56": {},
  "Крекеры|418|9|14|68": {},
  "Ржаные лепешки|390|5|18|56": {},
  "Рожки сдобные|336|16|1|70": {},
  "Сдоба обыкновенная|301|8|5|55": {},
  "Соломка сладкая|372|9|6|69": {},
  "Сухари|336|16|1|70": {},
  "Сушки простые|339|11|1|71": {},
  "Хлеб бородинский (мука ржаная обойная и пшеничная 2 сорта)|201|7|1|40": {},
  "Хлеб зерновой (мука в/с и зерно дробленое)|228|9|1|45": {},
  "Хлеб из цельной пшеницы|247|13|3|35": {},
  "Хлеб подовый из обойной муки|208|8|2|40": {},
  "Хлеб пшеничный, формовой из муки высшего сорта|235|8|1|49": {},
  "Хлеб ржано-пшеничный|336|16|1|70": {},
  "Хлеб ржано-пшеничный, минский|336|16|1|70": {},
  "Хлеб ржано-пшеничный, украинский подовый|336|16|1|70": {},
  "Хлеб ситный молочный|214|8|1|47": {},
  "Хлебцы докторские (мука в/с и отруби пшеничные)|242|8|3|46": {},
  "Чесночный белый хлеб|427|11|19|54": {},
  "Чесночный черный хлеб|408|10|23|41": {},
  "Омлет|154|11|12|1": {},
  "Яичница глазунья|243|13|21|1": {},
  "Яичный белок куриный (сухой)|350|82|2|1": {},
  "Яичный белок куриный (сырой)|52|11|0|1": {},
  "Яичный белок куриный (вареный)|41|9|0|1": {},
  "Яичный желток куриный (сухой)|612|31|52|5": {},
  "Яичный желток куриный (сырой)|322|16|27|4": {},
  "Яичный желток куриный (вареный)|322|16|27|4": {},
  "Яичный порошок|542|46|37|5": {},
  "Яйцо гусиное, цельное (сырое)|185|14|13|1": {},
  "Яйцо индюшачье, цельное (сырое)|171|14|12|1": {},
  "Яйцо куриное (сваренное вкрутую)|157|13|12|1": {},
  "Яйцо куриное (сваренное всмятку)|158|13|12|1": {},
  "Яйцо куриное, пашот (сваренное без скорлупы)|138|13|10|1": {},
  "Яйцо куриное, цельное (сырое)|143|13|10|1": {},
  "Яйцо перепелиное, цельное (сырое)|158|13|11|0": {},
  "Яйцо утиное, цельное (сырое)|185|13|14|2": {},
  "Борщ (на мясном бульоне)|58|4|3|4": {},
  "Борщ (на постном бульоне)|38|1|1|6": {},
  "Бульон из кур или индеек прозрачный|51|4|4|0": {},
  "Бульон костный|29|4|1|0": {},
  "Бульон мясной прозрачный|54|7|3|0": {},
  "Бульон рыбный|49|10|1|0": {},
  "Окрошка|57|2|3|5": {},
  "Рассольник домашний (на мясном бульоне)|38|1|2|5": {},
  "Свекольник холодный|63|2|4|6": {},
  "Солянка мясная|153|9|11|6": {},
  "Суп гороховый (на постном бульоне)|54|2|3|5": {},
  "Суп грибной|51|1|3|5": {},
  "Суп из говядины|42|2|3|3": {},
  "Суп из утки|283|11|23|9": {},
  "Суп фасолевый (на мясном бульоне)|66|2|5|4": {},
  "Суп фасолевый (на постном бульоне)|48|2|2|7": {},
  "Суп-крем из тыквы|93|3|5|10": {},
  "Суп-лапша домашняя (на мясном бульоне)|48|1|2|6": {},
  "Суп-харчо (на мясном бульоне)|44|2|2|4": {},
  "Сырный суп|93|5|7|3": {},
  "Уха рыбацкая|67|9|2|4": {},
  "Шурпа (на мясном бульоне)|44|2|2|4": {},
  "Щи из свежей капусты (на постном бульоне)|33|1|2|3": {},
  "Щи из щавеля (на постном бульоне)|45|2|3|2": {},
  "Запеканка грибная|145|5|10|10": {},
  "Запеканка из кабачков|142|5|12|3": {},
  "Запеканка из отварного картофеля|133|3|11|7": {},
  "Запеканка из творога (творог нежирный)|168|18|4|14": {},
  "Запеканка из тыквы|228|4|13|25": {},
  "Запеканка из яблок|148|0|8|20": {},
  "Запеканка капустная|162|7|13|5": {},
  "Запеканка пшенная|246|7|6|45": {},
  "Запеканка рыбная|164|10|12|5": {},
  "Запеченные творожные клецки|214|10|17|6": {},
  "Сладкая запеканка из фасоли|299|11|16|31": {},
  "Азу|178|9|12|7": {},
  "Антрекот|317|22|25|1": {},
  "Бефстроганов|355|22|27|6": {},
  "Биточки паровые|281|20|20|7": {},
  "Бифштекс|384|28|30|2": {},
  "Голубцы с мясом и рисом|191|3|17|7": {},
  "Зразы|303|18|21|12": {},
  "Котлеты куриные, по 2-20|222|18|10|14": {},
  "Котлеты по-киевски|445|22|28|29": {},
  "Котлеты рубленые, баранина, по 1-442|240|14|15|13": {},
  "Котлеты рубленые, говядина, по 1-444|213|14|11|13": {},
  "Котлеты рубленые, свинина, по 1-440|466|14|46|0": {},
  "Кролик жареный|241|32|13|0": {},
  "Кролик отварной|194|26|10|0": {},
  "Курица жареная целиком (мясо с кожицей)|223|24|13|0": {},
  "Курица жареная, белое мясо (только мясо)|153|27|4|0": {},
  "Курица жареная, темное мясо (только мясо)|178|23|9|0": {},
  "Люля-кебаб (азербайджанское национальное блюдо)|339|20|25|10": {},
  "Манты с бараниной|205|12|10|18": {},
  "Пельмени отварные|219|10|14|14": {},
  "Печень, жаренная|300|24|21|4": {},
  "Плов с мясом|230|7|15|16": {},
  "Тефтели|159|10|9|10": {},
  "Цыплята табака (грузинское национальное блюдо)|351|29|25|3": {},
  "Чахохбили из курицы|120|7|9|3": {},
  "Шашлык из говядины|466|22|41|3": {},
  "Шницель|456|17|39|10": {},
  "Вареники с капустой|79|4|3|10": {},
  "Грибы жареные с картофелем|114|4|5|13": {},
  "Драники|69|3|1|13": {},
  "Капуста тушеная|102|3|6|10": {},
  "Картофель вареный (без кожуры, без добавления соли)|86|2|0|18": {},
  "Картофель вареный (в кожуре, без добавления соли)|78|3|0|14": {},
  "Картофель жареный (из вареного)|212|4|12|25": {},
  "Картофель жареный (из сырого)|203|4|11|25": {},
  "Картофельное пюре|82|2|5|9": {},
  "Картофельные крокеты|346|3|34|8": {},
  "Лук, жареный во фритюре|240|5|14|25": {},
  "Помидоры жареные|56|1|4|4": {},
  "Рагу из овощей|57|1|3|7": {},
  "Свекла тушеная|106|3|6|12": {},
  "Тушенная кольраби|74|4|5|3": {},
  "Тыква отварная|117|3|8|9": {},
  "Шницель из капусты|149|3|11|10": {},
  "Кальмары жареные|175|10|14|1": {},
  "Морской гребешок или креветки заливные|222|24|14|1": {},
  "Пельмени рыбные (полуфабрикат)|209|15|7|24": {},
  "Раки морские вареные|90|21|1|0": {},
  "Раки речные вареные|97|20|1|1": {},
  "Рыба жареная|208|17|11|11": {},
  "Рыба, жаренная во фритюре|245|13|16|14": {},
  "Рыбные котлеты|113|12|6|3": {},
  "Строганина из рыбы |173|34|4|0": {},
  "Тефтели рыбные|304|13|8|49": {},
  "Тушеная ставрида|70|6|4|3": {},
  "Фрикадельки рыбные|153|22|7|2": {},
  "Шницель рыбный натуральный|203|15|12|11": {},
  "Ванильный крем|191|5|13|15": {},
  "Вишневый мусс|151|6|0|34": {},
  "Желе из молока|192|6|11|18": {},
  "Желе из плодов или ягод свежих|69|3|0|16": {},
  "Клубничный пудинг|76|2|1|15": {},
  "Клюквенный мусс|71|1|0|18": {},
  "Крупеник|204|8|12|17": {},
  "Орешки творожные|271|9|17|22": {},
  "Самбук абрикосовый|115|2|0|28": {},
  "Сливки, взбитые шоколадные|205|3|20|4": {},
  "Яблоки в грильяже|146|0|3|32": {},
  "Яблоки в желе|111|3|3|18": {},
  "Яблоки в тесте жареные|221|3|8|36": {},
  "Ягодный мусс|167|1|1|41": {},
  "Салат Винегрет|76|2|5|7": {},
  "Салат Греческий|188|4|18|3": {},
  "Салат из белокачанной капусты (капуста, зелень, специи, раст.масло)|68|2|4|8": {},
  "Салат из редиски (редис, яйцо, зелень, специи, сметана)|106|2|9|4": {},
  "Салат из репы (репа, зелень, специи, подсолнечное масло)|143|2|9|14": {},
  "Салат из свежих овощей (томаты, огурец, лук, специи, раст.масло)|89|1|8|5": {},
  "Салат из свежих огурцов (огурец, специи, сметана)|57|1|5|3": {},
  "Салат из свежих помидоров (томаты, лук, зелень, специи, майонез)|146|4|12|4": {},
  "Салат из спаржи (спаржа, орковь, лук зеленый, специи, майонез)|238|2|24|4": {},
  "Салат из фасоли (фасоль, огурец соленый, яйцо, специи, раст.масло)|337|14|20|28": {},
  "Салат Мимоза|221|6|19|6": {},
  "Салат Оливье|207|7|16|9": {},
  "Салат Селедка под шубой|210|8|18|4": {},
  "Салат Цезарь|304|15|17|24": {},
  "Баранина тушеная|191|17|13|0": {},
  "Говядина отварная в собственном соку|214|15|17|0": {},
  "Говядина тушеная|220|17|17|0": {},
  "Гуляш бараний|213|14|16|4": {},
  "Гуляш говяжий|212|17|14|4": {},
  "Гуляш свиной|333|13|29|4": {},
  "Завтрак туриста (баранина)|210|18|15|0": {},
  "Завтрак туриста (говядина)|217|21|15|0": {},
  "Завтрак туриста (свинина)|347|17|31|0": {},
  "Конина тушеная|234|19|17|1": {},
  "Курица в собственном соку|183|23|10|0": {},
  "Мясо в белом соусе|201|18|13|4": {},
  "Паштет из печени гуся, (копченый)|462|11|44|5": {},
  "Паштет мясной (говяжий)|275|16|23|0": {},
  "Свинина жирная|491|12|49|0": {},
  "Свинина тушеная|349|15|32|0": {},
  "Утка в собственном соку|223|16|18|0": {},
  "Арбуз консервированный|37|1|0|9": {},
  "Горошек, зеленый, консервы|40|3|0|7": {},
  "Икра из баклажанов. Консервы|148|2|13|5": {},
  "Икра из кабачков Консервы|119|2|9|8": {},
  "Кукуруза, сладкая, желтая (в рассоле) Консервы|64|2|1|14": {},
  "Морская капуста, консервированная|17|1|0|3": {},
  "Огурцы соленые|11|1|0|2": {},
  "Оливки. Консервы|175|2|16|5": {},
  "Помидоры без кожицы. Консервы|12|1|0|2": {},
  "Помидоры с кожицей. Консервы|20|1|0|4": {},
  "Томатная паста. Консервы|102|5|0|19": {},
  "Томаты соленые|13|1|0|2": {},
  "Фасоль белая. Консервы|114|7|0|16": {},
  "Шпинат-пюре. Консервы|16|2|0|2": {},
  "Горбуша в томатном соусе. Консервы|130|15|6|4": {},
  "Горбуша натуральная. Консервы|136|21|6|0": {},
  "Камбала в томатном соусе. Консервы|88|18|2|0": {},
  "Камбала обжаренная в масле. Консервы|254|14|22|0": {},
  "Кета в томатном соусе. Консервы|88|18|2|0": {},
  "Кета натуральная. Консервы|129|22|5|0": {},
  "Килька в томатном соусе. Консервы|182|14|12|5": {},
  "Крабы консервированные|88|18|2|0": {},
  "Креветка антарктическая натуральная. Консервы|82|18|1|0": {},
  "Лещ в томатном соусе. Консервы|124|15|5|4": {},
  "Муксун в томатном соусе. Консервы|88|18|2|0": {},
  "Налим в томатном соусе. Консервы|88|18|2|0": {},
  "Осетр в томатном соусе. Консервы|164|14|12|3": {},
  "Осетр консервированный|88|18|2|0": {},
  "Печень трески. Консервы|613|4|66|1": {},
  "Сазан в томатном соусе. Консервы|143|12|9|4": {},
  "Сардины в масле. Консервы|88|18|2|0": {},
  "Сардины океанические, консервированные|166|19|10|0": {},
  "Севрюга в томатном соусе. Консервы|178|16|11|3": {},
  "Скумбрия в масле. Консервы|318|14|29|0": {},
  "Сом в томатном соусе. Консервы|126|13|6|4": {},
  "Ставрида в масле. Консервы|88|18|2|0": {},
  "Судак в томатном соусе. Консервы|119|14|5|3": {},
  "Треска копченая в масле. Консервы|290|21|23|0": {},
  "Тунец в воде. Консервы|128|24|3|0": {},
  "Тунец в масле. Консервы|186|27|8|0": {},
  "Шпроты в масле. Консервы|363|17|32|0": {},
  "Щука в томатном соусе. Консервы|110|14|4|3": {},
  "Абрикосы, консервированные|38|1|0|9": {},
  "Айва, консервированная|43|1|1|10": {},
  "Варенье из клубники|285|0|0|74": {},
  "Варенье из малины|273|1|0|70": {},
  "Вишня, консервированная|54|1|0|14": {},
  "Груши, консервированные|43|0|0|10": {},
  "Джем черносмородиновый|284|1|0|73": {},
  "Персики, консервированные|40|1|0|10": {},
  "Повидло из абрикосов|242|0|0|64": {},
  "Повидло из айвы|216|0|0|57": {},
  "Повидло из боярышника|168|0|0|45": {},
  "Повидло яблочное|250|0|0|65": {},
  "Пюре яблочное|82|1|0|19": {},
  "Сливы, консервированные|42|1|0|10": {},
  "Черника в собственном соку|38|1|1|8": {},
  "Яблоки в сиропе. Консервы|48|0|0|12": {},
  "Белый гриб маринованный|24|3|1|2": {},
  "Брусника моченая|24|0|0|5": {},
  "Виноград маринованный|66|1|1|15": {},
  "Вишня маринованная|45|1|0|11": {},
  "Каперсы консервированные|23|2|1|2": {},
  "Капуста маринованная|47|1|0|12": {},
  "Капуста цветная маринованная|28|3|0|4": {},
  "Квашеная капуста|27|2|0|5": {},
  "Лук маринованный|82|1|5|9": {},
  "Маринад овощной|120|1|8|12": {},
  "Маринованная свекла|42|2|0|9": {},
  "Маринованные стрелки чеснока|30|1|0|7": {},
  "Маринованный крыжовник|0|0|0|0": {},
  "Маринованный чеснок|42|2|0|9": {},
  "Маслины черные консервированные|115|1|11|3": {},
  "Морковь квашеная|26|1|0|5": {},
  "Огурец маринованный|12|1|0|2": {},
  "Перец сладкий маринованный|25|1|0|5": {},
  "Свекла квашеная|32|1|0|6": {},
  "Слива маринованная|64|0|0|17": {},
  "Томаты маринованные|15|2|0|2": {},
  "Тыква в сладком маринаде|91|0|0|24": {},
  "Беляш|261|15|15|19": {},
  "Блины|233|6|12|26": {},
  "Ватрушки (из дрожжевого теста)|319|13|12|43": {},
  "Капустный пирог|242|7|8|29": {},
  "Кулебяки (из дрожжевого теста)|206|11|4|32": {},
  "Оладьи|213|7|7|32": {},
  "Пироги закрытые|252|12|7|39": {},
  "Пирожки печеные из дрожжевого теста|286|14|9|39": {},
  "Пирожки печеные из пресного слоеного теста|390|14|25|30": {},
  "Пицца с луком и сыром|199|5|15|10": {},
  "Пицца с помидорами и сыром|222|4|18|13": {},
  "Профитроли|253|10|16|19": {},
  "Расстегаи|254|12|6|36": {},
  "Сочни творожные|261|9|10|36": {},
  "Чебуреки|279|13|16|24": {},
  "Ветчина (сабы легкие)|290|18|5|47": {},
  "Индейка (сабы легкие)|280|18|4|47": {},
  "Индейка и ветчина (сабы легкие)|290|19|4|47": {},
  "Итальянский Б.М.Т. (сабы особые)|450|22|20|48": {},
  "Куриная грудка (сабы сытные)|320|23|5|49": {},
  "Курица Терияки (сабы сытные)|380|26|5|60": {},
  "Курица-бекон с чесночным соусом (сабы сытные)|570|35|28|48": {},
  "Мелт (сабы сытные)|380|25|11|48": {},
  "Мясные шарики в соусе Маринара (сабы популярные)|480|21|18|60": {},
  "Овощной (сабы легкие)|230|9|3|45": {},
  "Острый итальянский (сабы особые)|520|22|28|47": {},
  "Ростбиф (сабы легкие)|310|26|5|45": {},
  "Сабвэй Клаб (сабы особые)|320|26|5|47": {},
  "Свинина Барбекю (сабы сытные)|436|25|8|44": {},
  "Стейк и сыр Чиз (сабы популярные)|449|33|7|47": {},
  "Тунец (сабы особые)|530|21|30|45": {},
  "Чиккен пицциола (сабы популярные)|347|24|4|44": {},
  "Барбекю Биф Рэп|509|22|25|28": {},
  "Биг Кинг|423|17|26|30": {},
  "Биг Кинг XXL|936|49|64|42": {},
  "Воппер|576|26|34|43": {},
  "Воппер Мини|319|14|16|29": {},
  "Воппер Мини с сыром|312|11|17|30": {},
  "Воппер с сыром|679|30|43|44": {},
  "Гриль Чикен|335|26|7|42": {},
  "Гриль Чикен Барбекю|693|36|35|55": {},
  "Гриль Чикен Рэп|315|25|8|17": {},
  "Гриль Чикен с сыром|419|31|14|42": {},
  "Двойной воппер|815|42|54|43": {},
  "Двойной воппер с сыром|899|47|60|44": {},
  "Криспи Чикен|485|18|30|36": {},
  "Криспи Чикен Рэп с соусом карри|484|19|25|27": {},
  "Криспи Чикен с сыром|527|21|33|36": {},
  "Лонг Чикен|580|23|34|47": {},
  "Лонг Чикен с сыром|664|28|40|48": {},
  "Наггетс Бургер|419|13|25|35": {},
  "Тендеркрисп|622|31|32|51": {},
  "Фиш Кинг|483|17|28|41": {},
  "Фиш Кинг с сыром|525|19|32|41": {},
  "Айс Твист клубника с печеньем|237|5|6|42": {},
  "Айс Твист шоколадная крошка|199|5|6|31": {},
  "Горячий Блонди|441|7|27|42": {},
  "Горячий Блонди с мороженым|511|9|29|54": {},
  "Горячий Брауни|456|6|31|39": {},
  "Горячий Брауни с мороженым|526|8|33|50": {},
  "Мороженое Рожок|108|3|2|18": {},
  "Сандэй Ванильный|182|5|5|29": {},
  "Сандэй Карамельный|265|6|6|43": {},
  "Сандэй Клубничный|219|5|5|39": {},
  "Сандэй Шоколадный|268|6|7|40": {},
  "Мясная лазанья 1 порция|629|31|47|20": {},
  "Паста Пенне Аррабьятам 1 порция|752|18|34|93": {},
  "Паста Пенне Балоньезе 1 порция|800|33|34|90": {},
  "Паста Пенне дель Фатторе 1 порция|968|32|52|93": {},
  "Пицца IL Патио|715|43|34|60": {},
  "Пицца Баварезе|695|36|36|57": {},
  "Пицца Барбекью|692|40|32|61": {},
  "Пицца Ветчина и Грибы|829|47|38|87": {},
  "Пицца Дары Моря|875|48|26|112": {},
  "Пицца Кваттро Стаджони|961|43|37|114": {},
  "Пицца Кваттро Формаджи|780|33|42|68": {},
  "Пицца Маргарита|803|28|22|69": {},
  "Пицца Мексикана|711|42|36|55": {},
  "Пицца Парма и Грибы|926|43|33|116": {},
  "Пицца Пепперони|863|39|40|86": {},
  "Пицца Примавера|695|20|27|94": {},
  "Пицца Филадельфия|954|50|45|87": {},
  "Спагетти Крудайола 1 порция|672|18|28|86": {},
  "Спагетти с тигровыми креветками 1 порция|953|28|53|92": {},
  "Бекон с луком|101|6|9|3": {},
  "Большой мясной бутерброд|600|21|38|44": {},
  "Большой рыбный бутерброд с семгой|726|23|53|39": {},
  "Брынза с растительным маслом|212|12|18|0": {},
  "Вареники с вишней 1 порция|378|3|35|13": {},
  "Вареники с творогом 1 порция|609|18|54|14": {},
  "Горячий бутерброд с ветчиной и сыром|435|18|23|38": {},
  "Гренки «Восемь злаков»|239|3|17|19": {},
  "Гречневая каша с овощами 1 порция|113|5|4|15": {},
  "Картофель печеный с маслом|323|10|15|38": {},
  "Картофель печеный с мясом и маслом|362|15|17|38": {},
  "Картофель печеный с растительным маслом|327|5|18|37": {},
  "Картофель печеный с сыром|290|17|8|38": {},
  "Картофель печеный с сыром и маслом|441|22|22|38": {},
  "Корнишоны с маслинами|63|1|6|2": {},
  "Крабовое мясо с майонезом 1 порция|232|7|22|1": {},
  "Красная рыбка|35|1|4|0": {},
  "Куриный пай|448|16|30|28": {},
  "Печеный картофель со свежим укропом и сыром|406|10|23|39": {},
  "Пирожок с капустой|100|1|9|4": {},
  "Пирожок с мясом и баклажанам|120|4|10|4": {},
  "Сосиски в горчичном соусе|145|7|11|4": {},
  "Топленый сыр с брокколи|123|5|10|3": {},
  "Тост куриный с огурцом|429|17|17|52": {},
  "Биг Мак|510|27|26|41": {},
  "Биг Тейсти|850|44|52|50": {},
  "Биф Ролл|520|20|29|43": {},
  "Гамбургер|255|13|9|30": {},
  "Двойной Роял Чизбургер|639|42|41|26": {},
  "Макчикен|435|20|19|44": {},
  "Роял де Люкс|555|30|29|42": {},
  "Роял Чизбургер|530|32|28|36": {},
  "Филе-о-Фиш|320|14|13|36": {},
  "Фиш Ролл|475|17|23|49": {},
  "Цезарь Ролл|510|22|24|50": {},
  "Чизбургер|305|16|13|30": {},
  "Чикен Бекон|680|27|36|60": {},
  "Чикен Макнаггетс 1 кусочек|43|3|3|2": {},
  "Чикенбургер|360|12|16|41": {},
  "Картофель по-деревенски (1 порция)|315|5|16|38": {},
  "Картофель фри (1 большая порция)|530|8|26|66": {},
  "Картофель фри (1 маленькая порция)|235|3|12|29": {},
  "Картофель фри (1 средняя порция)|340|5|17|42": {},
  "Морковные палочки (Макдональдс)|27|1|0|6": {},
  "Салат овощной (Макдональдс)|25|2|0|8": {},
  "Салат Цезарь (Макдональдс)|195|15|10|10": {},
  "Яблочные дольки (Макдональдс)|38|0|0|8": {},
  "Вафельный рожок (Макдональдс)|130|3|3|23": {},
  "Вишнёвый пирожок (Макдональдс)|180|3|7|25": {},
  "Макфлурри де Люкс карамельно-шоколадное (Макдональдс)|400|7|10|71": {},
  "Макфлурри де Люкс клубнично-шоколадное (Макдональдс)|340|6|8|61": {},
  "Макфлурри с вафельно-шоколадной крошкой (Макдональдс)|270|6|8|43": {},
  "Макфлурри с рисом и клубникой (Макдональдс)|290|5|6|54": {},
  "Маффин с черной смородиной (Макдональдс)|370|5|18|47": {},
  "Маффин с шоколадом (Макдональдс)|350|6|12|55": {},
  "Молочный коктейль ваниль (Макдональдс)|250|6|5|45": {},
  "Молочный коктейль клубника (Макдональдс)|250|6|3|45": {},
  "Молочный коктейль шоколад (Макдональдс)|245|6|5|44": {},
  "Мороженое карамельное (Макдональдс)|325|5|7|60": {},
  "Мороженое клубничное (Макдональдс)|265|5|5|50": {},
  "Мороженое шоколадное (Макдональдс)|315|6|9|52": {},
  "Двойной Эспрессо (Макдональдс)|3|0|0|0": {},
  "Капучино (Макдональдс)|75|4|4|6": {},
  "Кофе (Макдональдс)|6|1|0|1": {},
  "Кофе Глясе (Макдональдс)|120|3|3|20": {},
  "Кофе Латте (Макдональдс)|125|6|7|10": {},
  "Чай чёрный/зелёный (Макдональдс)|0|0|0|0": {},
  "Кетчуп (Макдональдс)|30|0|0|7": {},
  "Майонез (Макдональдс)|150|0|16|1": {},
  "Соус барбекю (Макдональдс)|40|0|0|10": {},
  "Соус карри (Макдональдс)|50|0|0|12": {},
  "Соус кисло-сладкий (Макдональдс)|50|0|0|12": {},
  "Соус сырный (Макдональдс)|90|1|9|1": {},
  "Биггер (оригинальный)|619|33|28|59": {},
  "Биггер (острый)|580|31|24|59": {},
  "Боксмастер из тостера (оригинальный)|690|21|41|57": {},
  "Боксмастер из тостера (острый)|708|22|44|53": {},
  "Куриные крылышки 1 крылышко|84|4|5|4": {},
  "Курица 1 кусочек|130|10|7|8": {},
  "Лонгер (оригинальный)|296|12|13|31": {},
  "Лонгер (острый)|248|12|6|35": {},
  "Мини твистер (оригинальный)|267|10|12|28": {},
  "Мини твистер (острый)|254|9|10|29": {},
  "Сандвич Зингер|362|18|16|34": {},
  "Сандвич Классик|345|17|13|38": {},
  "Стрипсы из куриного филе 1 стрипс|81|6|4|3": {},
  "Твистер из тостера (оригинальный)|449|19|19|49": {},
  "Твистер из тостера (острый)|424|18|16|50": {},
  "Большой Датский хот-дог|335|12|21|22": {},
  "Большой Французский хот-дог|278|12|15|22": {},
  "Горячий сэндвич|510|14|33|35": {},
  "Датский хот-дог|287|11|19|16": {},
  "Рулле с сосиской|213|8|14|14": {},
  "Французский хот-дог|254|11|12|25": {},
  "Чиз-дог по-французски|463|12|29|35": {},
  "Абокадо ролл 6 штук|84|2|1|17": {},
  "Аляска 6 штук|162|8|5|22": {},
  "Гейша ролл 6 штук|174|6|8|19": {},
  "Итиго панкэки 1 порция|304|4|2|67": {},
  "Карамеру панкэки 1 порция|312|4|3|67": {},
  "Кудамоно Мориавасэ 1 порция|160|2|1|36": {},
  "Куро ёру 1 порция|383|8|11|64": {},
  "Кэси Пай 1 порция|407|11|32|20": {},
  "Манила ролл 1 порция|293|8|9|45": {},
  "Наполеон-сан 1 порция|620|7|42|53": {},
  "Пайнаппуру 1 порция|153|1|1|36": {},
  "Сека сарада 1 порция|298|8|5|57": {},
  "Тирамису (Сыр Маскарпоне, печенье Савоярди) 1 порция|472|15|29|39": {},
  "Гречка Греческая с брынзой, беконом и зеленью 1 порция|323|13|28|23": {},
  "Гречка Две сосики 1 порция|392|20|38|23": {},
  "Гречка постная 1 порция|440|10|13|50": {},
  "Гречка с бужениной 1 порция|388|17|36|25": {},
  "Гречка с ветчиной и сыром 1 порция|349|20|27|24": {},
  "Гречка с грибами 1 порция|275|9|15|25": {},
  "Гречка с гусиным паштетом, огурцами и зеленью 1 порция|130|18|13|28": {},
  "Гречка с капустой и яйцом 1 порция|250|9|10|25": {},
  "Гречка с куриной грудкой-гриль 1 порция|308|15|22|23": {},
  "Гречка с семгой 1 порция|263|16|10|23": {},
  "Гурьевская каша с карамелью, яблоком и орехом 1 порция|640|7|16|78": {},
  "Гурьевская каша с клубникой и миндальным орехом 1 порция|424|6|9|52": {},
  "Гурьевская каша с лесной ягодой и миндальным орехом 1 порция|388|6|9|47": {},
  "Гурьевская каша с мёдом и миндальным орехом 1 порция|530|6|9|67": {},
  "Гурьевская каша с чипами и миндальным орехом 1 порция|304|6|9|35": {},
  "Гурьевская каша с шоколадом и миндальным орехом 1 порция|488|7|14|58": {},
  "Каша со сгущеным молоком и миндальным орехом 1 порция|565|10|12|68": {},
  "Борщ Теремковский 1 порция|141|4|15|9": {},
  "Борщ Теремковский постный 1 порция|66|2|0|8": {},
  "Похлебка Гороховая постная 1 порция|384|21|2|42": {},
  "Похлебка Гороховая с копченостями 1 порция|457|24|11|45": {},
  "Похлёбка грибная с чипами 1 порция|274|17|34|11": {},
  "Уха из форели по-фински 1 порция|199|13|15|13": {},
  "Блин Лакомка со сливочным творожком и курагой|460|8|18|51": {},
  "Блин Лесная ягода|451|8|18|50": {},
  "Блин с мёдом|593|8|18|70": {},
  "Блин с сахаром|436|8|18|48": {},
  "Блин с шоколадом|551|9|23|61": {},
  "Блин с шоколадом и бананом|706|10|23|82": {},
  "Блин со сгущенным молоком|627|12|21|71": {},
  "Блин со сливочной карамелью и яблоком|702|10|25|81": {},
  "Блинчик с клубничным вареньем|364|6|12|42": {},
  "Блин E-mail с грибами и сыром|533|23|40|40": {},
  "Блин большой мясной|541|21|28|50": {},
  "Блин Греческий с брынзой, беконом и зеленью|342|11|28|27": {},
  "Блин Две сосиски|560|23|50|38": {},
  "Блин двойной с ветчиной и сыром|517|23|39|39": {},
  "Блин Илья Муромец (буженина с грибами, сыром, зеленью)|505|24|48|31": {},
  "Блин с бужениной|481|16|38|38": {},
  "Блин с ветчиной|427|13|26|39": {},
  "Блин с гусиным паштетом, огурцами и зеленью|489|21|26|43": {},
  "Блин с двойной красной икрой|524|36|28|39": {},
  "Блин с капустой и яйцом|416|12|22|40": {},
  "Блин с красной икрой|384|21|20|32": {},
  "Блин с куриной грудкой-гриль|415|17|32|32": {},
  "Блин с маслом|367|8|18|38": {},
  "Блин с сёмгой|431|19|23|38": {},
  "Блин с сыром|456|18|30|38": {},
  "Блин со сметаной|441|10|31|40": {},
  "Блинчик с ветчиной и сыром|265|9|17|23": {},
  "Блинчик с грибами|280|8|18|25": {}
}

export default data;